function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#F1F252"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#gocardless-symbol-dawn_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F1F252",
  d: "M-17.514-10.865h70.703v81.081h-70.703z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.8 9.035c3.254 0 5.086.532 5.086.532l5.407 11.058-.046.048-6.966-4.154c-4.032-2.413-6.966-3.67-9.348-3.573-2.52.048-4.032 2.077-4.032 5.022.091 7.533 7.241 16.806 14.344 16.806 2.9 0 4.408-.936 5.292-2.067L24.02 21.154v-.048h14.434c.23 1.061.32 2.561.32 3.138 0 8.453-6.461 15.26-14.434 15.26-7.973 0-14.483-6.807-14.483-15.26 0-8.452 6.462-15.212 14.94-15.212l.002.003z",
  fill: "#0A081B"
}));
function SvgGocardlessSymbolDawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gocardless-symbol-dawn_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref), _ref2);
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIyM183MzEyIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiPgo8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyNCIgZmlsbD0iI0YxRjI1MiIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjIzXzczMTIpIj4KPHJlY3QgeD0iLTE3LjUxMzciIHk9Ii0xMC44NjUyIiB3aWR0aD0iNzAuNzAyNyIgaGVpZ2h0PSI4MS4wODExIiBmaWxsPSIjRjFGMjUyIi8+CjxwYXRoIGQ9Ik0yNC43OTkyIDkuMDM0OUMyOC4wNTQgOS4wMzQ5IDI5Ljg4NTcgOS41NjY4MyAyOS44ODU3IDkuNTY2ODNMMzUuMjkyNiAyMC42MjUyTDM1LjI0NzIgMjAuNjczM0wyOC4yODEgMTYuNTE5NEMyNC4yNDkyIDE0LjEwNTcgMjEuMzE0NyAxMi44NDkzIDE4LjkzMyAxMi45NDU2QzE2LjQxMjUgMTIuOTkzNyAxNC45MDEyIDE1LjAyMjUgMTQuOTAxMiAxNy45NjgyQzE0Ljk5MiAyNS41MDA4IDIyLjE0MjUgMzQuNzczNiAyOS4yNDQ5IDM0Ljc3MzZDMzIuMTQ0NiAzNC43NzM2IDMzLjY1MzIgMzMuODM4IDM0LjUzNyAzMi43MDczTDI0LjAxOTUgMjEuMTU0NVYyMS4xMDY0SDM4LjQ1NEMzOC42ODM2IDIyLjE2NzUgMzguNzc0NCAyMy42NjcxIDM4Ljc3NDQgMjQuMjQ0NUMzOC43NzQ0IDMyLjY5NjcgMzIuMzEyOCAzOS41MDQ5IDI0LjMzOTkgMzkuNTA0OUMxNi4zNjcxIDM5LjUwNDkgOS44NTc0MiAzMi42OTY3IDkuODU3NDIgMjQuMjQ0NUM5Ljg1NzQyIDE1Ljc5MjMgMTYuMzE5IDkuMDMyMjMgMjQuNzk2NSA5LjAzMjIzTDI0Ljc5OTIgOS4wMzQ5WiIgZmlsbD0iIzBBMDgxQiIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgGocardlessSymbolDawn as ReactComponent };